import * as React from "react";
import { Typography } from "@mui/material";
import { getBrandingColors } from "./brandingUtils";
import { layout } from "./templateLayout";

export default function RegistrationPageFooter({ branding = {} }) {
  if (!branding.footerText) return null;

  const { accent } = getBrandingColors(branding);

  return (
    <Typography sx={{ ...layout.footer, color: accent }}>
      {branding.footerText}
    </Typography>
  );
}
